import initProductFilters from './filters.controller';
import { initListingControls } from './listing';

/**
 * Фасад для модуля фильтров товаров. Сохраняет публичный API.
 */
const ProductFilters = () => {
    initListingControls();
    initProductFilters();
};

export default ProductFilters;
